// extracted by mini-css-extract-plugin
export var messageSideLeft = "_h6-1";
export var messageSideRight = "_h6-2";
export var subscribeToBackInStockBubbleContainer = "_h6-0";